import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CalamityNoteModel } from 'app/calamity/models/calamity-note.model';
import { GenericService } from 'app/_services/generic.service';

@Injectable({
    providedIn: 'root',
})

export class CalamityNoteService extends GenericService<CalamityNoteModel> {
    constructor(private http: HttpClient) {
        super(http, '/CalamityNote/')
    }

    private generateHeaders() {
        return {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          }),
        };
      }

    getNotesByCalamityId(calamityId) {
        return this.http.get(
          this.rootUrl + "/CalamityNote/getByCalamityId/" + calamityId,
          this.generateHeaders()
        );
      }
}